import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AdmissionDiagnosisForm } from '../../models';

/**
 * INFO: add comment
 */
@Component({
    selector: 'mona-admission-diagnosis-form',
    templateUrl: './admission-diagnosis-form.component.html',
    styleUrls: ['./admission-diagnosis-form.component.scss'],
})
export class AdmissionDiagnosisFormComponent {
    /**
     * Form group
     */
    @Input() formGroup: FormGroup<AdmissionDiagnosisForm>;

    /**
     * Is bed side mode
     */
    @Input() isBedSideMode: boolean;

    /**
     * Is form active / visible
     */
    @Input() isActive: boolean;

    /**
     * Max textarea rows count size
     */
    @Input() textareaMaxRows = 40;

    /**
     * Keyboard enter clicked
     */
    @Output() keyboardEnterClicked: EventEmitter<void> = new EventEmitter();
}
